import userSelects from "./userSelects";

export default function () {
    if (!$('body').hasClass('homepage')) {
        return false;
    }

    userSelects();

    /**
     * It positions user to the first invalid-feedback
     * @type {NodeListOf<Element>}
     */
    const invalidFeebacks = document.querySelectorAll('.invalid-feedback');
    if (invalidFeebacks) {
        $('html,body').animate({
            scrollTop: invalidFeebacks[0]?.getBoundingClientRect().top - 100
        },'slow');
    }
}
